import Form from "./Form";

export default class Manager {

  registeredFieldTypes = [];
  static debug = true;
  static clearOnSuccess = true;

  forms={}
  formsConfig={}

  init(params = {
    DOM: null,
    debug:true,
    clearOnSuccess: true,
    forms:{}
  }) {
    this.DOM = params.DOM ?? document;
    Manager.debug = !!(params.debug ?? true)
    Manager.clearOnSuccess = !!(params.clearOnSuccess ?? true)
    this.formsConfig = params.forms ?? {};
    this.findForms()
    this.initForms();
  }

  destroy({DOM}){
    for (let formName of Object.keys(this.forms)){
      for (let form of this.forms[formName]){
        if (DOM.contains(form.getFormElement())){
          form.destroy();
        }
      }
    }
  }

  /*
  * Initialisation
  * */
  findForms() {
    console.log(this.DOM);
    this.formsEls = this.DOM.querySelectorAll('form[data-wkn-form]')
  }

  initForms() {
    for (let form of this.formsEls){
      const name = form.dataset.wknForm;
      if (!(name in this.forms)){
        this.forms[name] = [];
      }
      this.forms[name].push(new Form(form, this.formsConfig[name] ?? {}))
    }
  }

  registerFieldType(fieldType){
    this.registeredFieldTypes.push(fieldType)
  }

  /*
  * Utils
  * */

  getForms(name){
    return this.forms[name];
  }

  static log(...anything){

    if (this.debug){
      console.log("%c[FormsManager]", 'color:#FF5851', ...anything)
    }
  }
}


